// Akhilesh added for paymnet failure


// import React, { useEffect, useState } from "react";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import PaymentServices from "../../services/externalServices/TicketServices/paymentServices";
// import moment from "moment";

// const PaymentStatus = () => {
//   const { id } = useParams(); // merchantTransactionId
//   const [status, setStatus] = useState("Checking payment status...");
//   const [error, setError] = useState("");
//   const [isProcessing, setIsProcessing] = useState(true);
//   const [bookingDetails, setBookingDetails] = useState(null);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [paymentStatus, setPaymentStatus] = useState("checking");

//   // Extract state from location or sessionStorage
//   const {
//     showtimeId,
//     theatreId,
//     bookedSeats,
//     date,
//     time,
//     totalPrice,
//     movie,
//     nameOfTheatre,
//     phoneNumber,
//     priceSplit,
//     bookingId
//   } =
//     location.state ||
//     JSON.parse(sessionStorage.getItem("tempPhonePeBooking")) ||
//     {};

//   console.log('in the paymnet Status==========****************************=',bookingId);


//   useEffect(() => {
//     const temporaryData = JSON.parse(
//       sessionStorage.getItem("tempPhonePeBooking")
//     );
//     console.log("temporaryData++++++++++++++++++++++++++++++++++++++++++++++++++++++", temporaryData);

//     const handlePaymentValidation = async () => {
//       if (!id) {
//         setError("No transaction ID found");
//         setIsProcessing(false);
//         return;
//       }

//       try {
//         // Step 1: Validate payment with PhonePe/backend
//         // const validationRes = await axios.get(
//         //   `https://ticket.wmdservices.asia/api/payment/validate/${id}`
//         //   // `http://localhost:4123/api/payment/validate/${id}`

//         // );

//         const validationRes = await PaymentServices.validate(id);

//         const statusCode = validationRes?.code;
//         console.log("validtion res=========", statusCode);

//         // if (validationRes.code==="PAYMENT_PENDING") {
//         //   throw new Error('Payment validation failed');
//         // }




//         // Step 2: Create booking record
//         const finalPriceSplit = priceSplit || {
//           baseAmount: {
//             key: "Ticket Price",
//             value: totalPrice?.toFixed(2),
//           },
//           tax: {
//             isIGST: { value: false },
//             cgst: {
//               key: "CGST (9%)",
//               value: (totalPrice * 0.09)?.toFixed(2),
//             },
//             sgst: {
//               key: "SGST (9%)",
//               value: (totalPrice * 0.09)?.toFixed(2),
//             },
//             total: {
//               key: "Total Tax",
//               value: (totalPrice * 0.18)?.toFixed(2),
//             },
//           },
//           priceAfterTax: {
//             key: "Sub-Total",
//             value: (totalPrice * 1.18).toFixed(2),
//           },
//           finalAmount2: {
//             key: "Grand Total",
//             value: (totalPrice * 1.18)?.toFixed(2),
//           },
//         };



//         let transactionStatus = "Pending";

//         if (statusCode === "PAYMENT_SUCCESS") {
//           transactionStatus = "Success";
//           // setPaymentStatus("success");
//         } else if (statusCode === "PAYMENT_PENDING") {
//           transactionStatus = "Pending";
//           // setPaymentStatus("pending");
//         } else {
//           transactionStatus = "Failed";
//           // setPaymentStatus("failed");
//           setError("Payment failed or was cancelled.");
//         }


//         const bookingPayload = {
//           movieId: movie?._id,
//           theatreId,
//           showtimeId,
//           bookedSeats,
//           // date: moment(date).format("YYYY/MM/DD"),
//           date: moment(date).format("YYYY-MM-DD"),
//           time,
//           totalAmount: totalPrice,
//           taxes: 0, // 18% tax
//           transactionId: id,
//           // transactionStatus: "Success",
//           transactionStatus: transactionStatus,
//           paymentMethod: "PhonePe",
//           paymentMode: "Online",
//           priceSplit: finalPriceSplit,
//           paymentDetails: validationRes?.data,
//           bookingId
//         };

//         console.log("bookingPayload", bookingPayload);
//         const bookingRes = await PaymentServices.createManualBooking(
//           bookingPayload
//         );







//         if (statusCode === "PAYMENT_PENDING") {
//           // setError('Your payment is still processing. Please wait a moment or check again.');
//           setIsProcessing(false);
//            setPaymentStatus("pending");

//           return;
//         }

//         if (statusCode !== "PAYMENT_SUCCESS") {
//           setPaymentStatus("failed");
//           setError("Payment failed or was cancelled.");
//           setIsProcessing(false);
//           return;
//         }

//         setPaymentStatus("success");

//         // // Step 2: Create booking record
//         // const finalPriceSplit = priceSplit || {
//         //   baseAmount: {
//         //     key: "Ticket Price",
//         //     value: totalPrice?.toFixed(2),
//         //   },
//         //   tax: {
//         //     isIGST: { value: false },
//         //     cgst: {
//         //       key: "CGST (9%)",
//         //       value: (totalPrice * 0.09)?.toFixed(2),
//         //     },
//         //     sgst: {
//         //       key: "SGST (9%)",
//         //       value: (totalPrice * 0.09)?.toFixed(2),
//         //     },
//         //     total: {
//         //       key: "Total Tax",
//         //       value: (totalPrice * 0.18)?.toFixed(2),
//         //     },
//         //   },
//         //   priceAfterTax: {
//         //     key: "Sub-Total",
//         //     value: (totalPrice * 1.18).toFixed(2),
//         //   },
//         //   finalAmount2: {
//         //     key: "Grand Total",
//         //     value: (totalPrice * 1.18)?.toFixed(2),
//         //   },
//         // };

//         // const bookingPayload = {
//         //   movieId: movie?._id,
//         //   theatreId,
//         //   showtimeId,
//         //   bookedSeats,
//         //   date: moment(date).format("YYYY/MM/DD"),
//         //   time,
//         //   totalAmount: totalPrice,
//         //   taxes: 0, // 18% tax
//         //   transactionId: id,
//         //   transactionStatus: "Success",
//         //   paymentMethod: "PhonePe",
//         //   paymentMode: "Online",
//         //   priceSplit: finalPriceSplit,
//         //   paymentDetails: validationRes?.data,
//         // };

//         // console.log("bookingPayload", bookingPayload);
//         // const bookingRes = await PaymentServices.createManualBooking(
//         //   bookingPayload
//         // );

//         if (
//           bookingRes?.message ===
//           "Manual booking with payment created successfully"
//         ) {
//           // Clear temporary storage
//           // sessionStorage.removeItem('tempPhonePeBooking');

//           // Immediately navigate to payment ticket page
//           navigate("/paymentTicket", {
//             state: {
//               movie,
//               theatreId,
//               showtimeId,
//               bookedSeats,
//               date,
//               time,
//               totalPrice,
//               taxes: totalPrice * 0.18,
//               ticketTotal: totalPrice * 1.18,
//               transactionId: id,
//               transactionStatus: "Success",
//               nameOfTheatre,
//               bookingId: bookingRes.bookingId,
//               previousPage: "/movies",
//               phoneNumber,
//             },
//             replace: true, // <--- Add this line!
//           });
//         } else {
//           throw new Error("Booking creation failed");
//         }
//       } catch (err) {
//         console.error("Payment processing error:", err);
//         setError(
//           err.response?.data?.message ||
//             err.message ||
//             "Payment processing failed"
//         );
//         setIsProcessing(false);
//       }
//     };

//     handlePaymentValidation();
//   }, [
//     // id,
//     // totalPrice,
//     // theatreId,
//     // showtimeId,
//     // bookedSeats,
//     // date,
//     // time,
//     // movie,
//     // nameOfTheatre,
//     // navigate,
//   ]);

//   return (
//     <div className="max-w-xl mx-auto mt-20 p-6 rounded-xl shadow-lg text-center bg-white">
//       {paymentStatus === "checking" && (
//         <>
//           <h2 className="text-2xl font-semibold mb-4 text-gray-700">
//             Processing your payment...
//           </h2>
//           <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto"></div>
//         </>
//       )}

//       {paymentStatus === "pending" && (
//         <>
//           <h2 className="text-2xl font-semibold text-yellow-500 mb-2">
//             ⏳ Payment Pending
//           </h2>
//           <p className="text-gray-600 mb-4">
//             Your payment is still being processed. This can take a few moments.
//           </p>
//           <button
//             onClick={() => window.location.reload()}
//             className="bg-yellow-500 hover:bg-yellow-600 text-white font-medium px-5 py-2 rounded"
//           >
//             Refresh Status
//           </button>
//         </>
//       )}

//       {paymentStatus === "failed" && (
//         <>
//           <h2 className="text-2xl font-semibold text-red-600 mb-2">
//             ❌ Payment Failed
//           </h2>
//           <p className="text-gray-600 mb-4">{error}</p>
//           <button
//             onClick={() => navigate("/movies")}
//             className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded"
//           >
//             Back to Movies
//           </button>
//         </>
//       )}
//     </div>
//   );
// };

// export default PaymentStatus;




import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import PaymentServices from "../../services/externalServices/TicketServices/paymentServices"; // adjust if needed
import ScreenLayoutServices from '../../services/externalServices/TicketServices/screenLayoutServices';
const PaymentStatus = () => {
  const { id } = useParams(); // merchantOrderId (v2) or merchantTransactionId (legacy)
  const location = useLocation();
  const navigate = useNavigate();

  const [paymentStatus, setPaymentStatus] = useState("checking");
  const [error, setError] = useState("");

  // Extract state from session or location
  const {
    showtimeId,
    theatreId,
    bookedSeats,
    date,
    time,
    totalPrice,
    movie,
    nameOfTheatre,
    phoneNumber,
    priceSplit,
    bookingId,
    maxTimeLimit,
    code,
    isSectionLayout
  } =
    location.state ||
    JSON.parse(sessionStorage.getItem("tempPhonePeBooking")) ||
    JSON.parse(sessionStorage.getItem("tempUnlimitBooking")) ||
    {};

  useEffect(() => {
    const validateAndPoll = async () => {
      if (!id || !bookingId) {
        setPaymentStatus("failed");
        setError("Missing transaction or booking ID.");
        return;
      }

      try {
        // For v2 (e.g., Unlimit), skip legacy validate and rely on booking polling
        const isUnlimitFlow = !!sessionStorage.getItem('tempUnlimitBooking');
        if (!isUnlimitFlow) {
          // Step 1: Validate payment with legacy PhonePe endpoint
          const validationRes = await PaymentServices.validate(id);
          const statusCode = validationRes?.code;
          if (statusCode === "PAYMENT_FAILED") {
            setPaymentStatus("failed");
            setError("Payment failed or was cancelled.");
            return;
          }
        }

        // Step 2: Start polling for booking status
        pollBookingStatus(bookingId, 0, 6); // 6 attempts, 4 seconds each
      } catch (err) {
        console.error("Validation failed:", err);
        setPaymentStatus("failed");
        setError("Error validating payment.");
      }
    };

    validateAndPoll();
  }, [id, bookingId]);











  const handleCancelBooking = async () => {
    // localStorage.removeItem('bookingExpiry');
    try {
      const payload = {
        showtimeId,
        theatreId,
        cancelledSeats: bookedSeats,
        date: moment(date).format('YYYY/MM/DD'),
        time,
      };
      console.log('payload=========================handlecancel', payload)

      const response = await ScreenLayoutServices.cancelBooking(payload);
      console.log('Cancel response:', response);

      // if (response.message === 'Seats cancelled successfully') {
      //   // Use functional update to ensure we have latest state
      //   setNeedsRefresh(prev => {
      //     // Navigate after state is updated
      //     if (navigateAfterCancel) {
      //       setTimeout(() => {
      //         // navigate(-1, { state: { forceReload: true } });

      //         navigate('/bookedSeats', {
      //           state: { theatreId, showtimeId, date, time, movie, nameOfTheatre, forceReload: true }
      //         });
      //       }, 0);
      //     }
      //     return true;
      //   });
      //   return true;
      // }
      // throw new Error('Failed to cancel booking');
    } catch (error) {
      console.error('Cancel error:', error);
      setError('Failed to cancel booking. Please try again.');
      return false;
    }
  };


  // const pollBookingStatus = async (bookingId, attempt, maxAttempts) => {
  //   try {
  //     // const res = await axios.get(`https://preprodticket.wmdservices.asia/api/payment/validateBooking/${bookingId}`);
  //     const res = await PaymentServices.validateBooking(bookingId)
  //     console.log('result from the validateBooking===', res);


  //     const status = res?.booking?.status;

  //     console.log(`Poll attempt ${attempt + 1}: ${status}`);

  //     if (status == "CONFIRMED") {

  //       // setPaymentStatus("success");
  //       navigate("/paymentTicket", {
  //         state: {
  //           movie,
  //           theatreId,
  //           showtimeId,
  //           bookedSeats,
  //           date,
  //           time,
  //           totalPrice,
  //           taxes: totalPrice * 0.18,
  //           ticketTotal: totalPrice * 1.18,
  //           transactionId: id,
  //           transactionStatus: "Success",
  //           nameOfTheatre,
  //           bookingId,
  //           previousPage: "/movies",
  //           phoneNumber,
  //           sendNoWhatsApp: true
  //         },
  //         replace: true
  //       });
  //     } else if (["FAILED_PAYMENT", "CANCELLED"].includes(status)) {
  //       setPaymentStatus("failed");
  //       setError("Booking was cancelled or payment failed.");
  //     } else if (attempt < maxAttempts) {
  //       console.log('🔄 Continuing to poll...');
  //       setTimeout(() => pollBookingStatus(bookingId, attempt + 1, maxAttempts), 4000);

  //     } else {
  //       console.log('🚨 TRIGGERING CANCEL BOOKING');
  //      await handleCancelBooking()
  //       setPaymentStatus("pending");
  //       setError(" Payment failed. If any amount has been deducted, please contact us for assistance.");
  //     }
  //   } catch (err) {
  //     console.error("Polling error:", err);
  //     setPaymentStatus("failed");
  //     setError("Something went wrong while checking your booking.");
  //   }
  // };



  const pollBookingStatus = async (bookingId, attempt, maxAttempts) => {
    try {
      const res = await PaymentServices.validateBooking(bookingId);
      console.log('result from the validateBooking===', res);

      const status = res?.booking?.status;
      console.log(`Poll attempt ${attempt}: ${status} - ${maxAttempts}`);
      // console.log('🔍 Debug - attempt:', attempt, 'maxAttempts:', maxAttempts);

      if (status === "CONFIRMED") {
        navigate("/paymentTicket", {
          state: {
            movie,
            theatreId,
            showtimeId,
            bookedSeats,
            date,
            time,
            totalPrice,
            taxes: totalPrice * 0.18,
            ticketTotal: totalPrice * 1.18,
            transactionId: id,
            transactionStatus: "Success",
            nameOfTheatre,
            bookingId,
            previousPage: "/movies",
            phoneNumber,
            sendNoWhatsApp: true,
            maxTimeLimit,
            code,
            isSectionLayout
          },
          replace: true
        });
        return;
      }

      if (["FAILED_PAYMENT", "CANCELLED"].includes(status)) {
        setPaymentStatus("failed");
        setError("Booking was cancelled or payment failed.");
        return;
      }


      console.log('status of the booking====================', status);

      // After max attempts with PAYMENT_INITIATED status
      if (attempt >= maxAttempts - 1 && status === "PAYMENT_INITIATED") {
        await handleCancelBooking();
        setPaymentStatus("pending");
        setError(`
        Your payment failed. 
        Please check your payment method/bank account.
        If amount was deducted, it may be refunded automatically within 24 hours.
        Contact support if issue persists.
      `);
        return;
      }

      // Continue polling if not reached max attempts
      if (attempt < maxAttempts - 1) {
        setTimeout(() => pollBookingStatus(bookingId, attempt + 1, maxAttempts), 4000);
        return;
      }



      // // ✅ CRITICAL FIX: Handle PAYMENT_INITIATED with proper attempt counting
      // if (status == "PAYMENT_INITIATED" || !status) {
      //   if (attempt < maxAttempts - 1) {
      //     console.log('🔄 Continuing to poll... (PAYMENT_INITIATED)');
      //     setTimeout(() => pollBookingStatus(bookingId, attempt + 1, maxAttempts), 4000);
      //     return;
      //   } else {
      //     // ✅ Max attempts reached with PAYMENT_INITIATED - trigger cancel
      //     console.log('🚨 Max attempts reached - TRIGGERING CANCEL BOOKING');
      //     await handleCancelBooking();
      //     setPaymentStatus("cancelled");
      //     setError("Payment timed out and booking has been cancelled. If any amount was deducted, please contact us for assistance.");
      //     return;
      //   }
      // }


      // // Fallback for unexpected statuses
      // if (attempt < maxAttempts - 1) {
      //   setTimeout(() => pollBookingStatus(bookingId, attempt + 1, maxAttempts), 4000);
      // } else {
      //   console.log('🚨 Max attempts reached - unknown status');
      //   await handleCancelBooking();
      //   setPaymentStatus("failed");
      //   setError("Payment failed. Please contact us for assistance.");
      // }

    } catch (err) {
      console.error("Polling error:", err);
      setPaymentStatus("failed");
      setError("Something went wrong while checking your booking.");
    }
  };










  return (
    <div className="max-w-xl mx-auto mt-20 p-6 rounded-xl shadow-lg text-center bg-white">
      {paymentStatus === "checking" && (
        <>
          <h2 className="text-2xl font-semibold mb-4 text-gray-700">
            Processing your payment...
          </h2>
          <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto"></div>
        </>
      )}

      {paymentStatus === "pending" && (
        <>
          <h2 className="text-2xl font-semibold text-yellow-500 mb-2">
            ❌ Payment Failed
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate("/moviebooking")}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded"
          >
            Back to Movies
          </button>
          {/* <button
            onClick={() => window.location.reload()}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-medium px-5 py-2 rounded"
          >
            Refresh Status
          </button> */}
        </>
      )}

      {paymentStatus === "failed" && (
        <>
          <h2 className="text-2xl font-semibold text-red-600 mb-2">
            ❌ Payment Failed
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate("/moviebooking")}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded"
          >
            Back to Movies
          </button>
        </>
      )}

      {paymentStatus === "success" && (
        <>
          <h2 className="text-2xl font-semibold text-red-600 mb-2">
            Payment success
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate("/movies")}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded"
          >
            Back to Movies
          </button>
        </>
      )}
    </div>
  );
};

export default PaymentStatus;
